import { useFormikContext } from 'formik';

const useResetButtonDisabled = () => {
  const { dirty, isSubmitting, handleReset } = useFormikContext();

  return [!dirty || isSubmitting, handleReset];
};

export default useResetButtonDisabled;
